<div class="container">
  <gds-spacer classes="spacer-70"></gds-spacer>
  <!--Inquiry Confirmation Heading -->

  <gds-heading
    [data]="{
      heading: pageLabels?.['inquiryForm_conf.heading'],
    }"
    class="A3-W6"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>

  <!--Inquiry Confirmation Description -->
  <gds-heading
    [data]="{
      heading: pageLabels?.['inquiryForm_conf.desc'],
    }"
    class="A5-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-70"></gds-spacer>

  <!--Inquiry Confirmation Details -->
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['inquiryForm_conf.lastName'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: inquiryForm?.value?.lastName,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>

  <gds-heading
    [data]="{
      heading: pageLabels?.['inquiryForm_conf.lastName_furigana'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>

  <gds-heading
    [data]="{
      heading: inquiryForm?.value?.last_name_furgina,
    }"
    class="A5-W5 email-field"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['inquiryForm_conf.firstName'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: inquiryForm?.value?.firstName,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>

  <gds-heading
    [data]="{
      heading: pageLabels?.['inquiryForm_conf.firstName_furigana'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: inquiryForm?.value?.first_name_furgina,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>

  <gds-heading
    [data]="{
      heading: pageLabels?.['inquiryForm_conf.email_address'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: inquiryForm?.value?.email,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>

  <gds-heading
    [data]="{
      heading: pageLabels?.['inquiryForm_conf.phone'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: inquiryForm?.value?.phoneNumber,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['inquiryForm_conf.type_heading'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: getSelectedLabel(inquiryForm?.value?.type),
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <div class="privacy-cls">
    <gds-heading
      [data]="{
        heading: pageLabels?.['inquiryForm_conf.agree_heading'],
      }"
      class="A5-W4"
    >
    </gds-heading>
  </div>
  <gds-spacer classes="spacer-30"></gds-spacer>

  <gds-body
    [data]="{
      description: pageLabels?.['inquiryForm_conf.agree_desc'],
    }"
    class="B1-W2"
  >
  </gds-body>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: inquiryForm?.value?.agree
        ? pageLabels?.['inquiryForm_conf.agree_option']
        : '',
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['inquiryForm_conf.inputForm_heading'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: inquiryForm?.get('replyInput')?.value,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <div class="privacy-cls">
    <gds-heading
      [data]="{
        heading: pageLabels?.['inquiryForm_conf.noReply_heading'],
      }"
      class="A5-W4"
    ></gds-heading>
  </div>
  <gds-spacer classes="spacer-30"></gds-spacer>

  <gds-body
    [data]="{
      description: pageLabels?.['inquiryForm_conf.noReply_desc'],
    }"
    class="B1-W2"
  ></gds-body>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: inquiryForm?.value?.reply
        ? pageLabels?.['inquiryForm_conf.noReply_option']
        : pageLabels?.['inquiryForm_conf.noReply_option1'],
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-70"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-70"></gds-spacer>
  <!--Inquiry-Confirm CTA-->
  <div class="align-left">
    <gds-buttons
      [data]="{
        type: 'secondary',
        href: '',
        label: pageLabels?.['inquiryForm_conf.return'],
        disabled: false,
        target: '',
      }"
      (buttonClicked)="inquiryBackBtn()"
    >
    </gds-buttons>
    <gds-spacer classes="vertical-spacer-50"></gds-spacer>
    <gds-buttons
      [data]="{
        type: 'primary',
        href: '',
        label: pageLabels?.['inquiryForm_conf.send'],
        disabled: !disableSendBtn && !isSubmitting ? 'false' : 'true',
        target: '',
      }"
      (buttonClicked)="onSubmitInquiryCreation()"
    >
    </gds-buttons>
  </div>
</div>
